/* eslint-disable */
import ls from 'local-storage';
import { extendDecorator, viewModelDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import ecommerceService from '@/js/common/Domain/Service/ecommerce';
import getPropertyForTourClick from '@/js/common/components/tour-page/services/getPropertyForTourClick';
import FreeCancellationInscriptionDesktop from '@/js/desktop/components/freeCancellationInscription';
import getShowcasePath from '@/js/common/Domain/Service/getShowcasePath';

import TooltipPopoverHtml from '@/js/common/components/tooltip/htmlTooltip/HtmlTooltip';
import '@/css/common/components/warranted-icon.scss';

import SimilarToursSelectDesktop from '../similarToursSelectDesktop/SimilarToursSelectDesktop';
import generateObjectToutProductFromRender from './services/generateObjectToutProductFromRender';
import tourProductComponentTemplate from './tourProductComponentTemplate.html';
import RoomCategoryPhotos from './roomCategoryPhotos/RoomCategoryPhotos';
import { getCheapestTravelataTourWithTransfer } from '@/js/common/components/hotel/tourProductUtils';
import {initCommonPromoTooltip} from "@/js/common/services/promoService";

@viewModelDecorator({
    defaults: {
        roomDescription: null,
    },
})
@extendDecorator({
    el: '<div class="HtlTr"></div>',
    events: {
        'mouseup .js-open-tour-page': 'tourSelectedOperators', // it is for all mouse events
        'click .hideDescriptionElement': 'hideRoomDescription',
        'click .js-open-tour-info-dg': 'openRoomInfoDg',
    },
    bindings: {
        '.js-open-tour-page': 'attr:{href:tourPageUrl}',
        '.js-room-category-name': 'text: roomStandardName, classes:{"have-description": roomDescriptionAvailable}, attr:{title: roomStandardName}',
        '.js-beds': 'toggle: beds',
        '.js-beds-text': 'text: beds',
        '.js-exists-operators': 'text: existsOperators',
    },
    computeds: {
        roomDescriptionAvailable: {
            deps: ['tour'],
            get: (tour) => !!tour?.get('room')?.description,
        },
        roomStandardName: {
            deps: ['tour'],
            get: (tour) => tour?.get('room')?.standardName || tour?.get('room')?.name,
        },
        beds: {
            deps: ['tour'],
            get: (tour) => tour?.get('room')?.beds?.toLowerCase() || null,
        },
        tourPageUrl: {
            deps: ['similarProducts'],
            get(similarProducts) {
                const shoucaseUrl = getShowcasePath();
                const hotelId = window.appConfig.hotelInfo.id;
                const paramsForRouter = {
                    sid: searchSessionService.getSearchId(),
                    hsid: searchSessionService.getHotelSearchId(),
                };
                let isPromoTooltipVisible = false;
                const tours = [].concat(this.model, similarProducts || []);
                const tourIdentities = _.chain(tours)
                    .groupBy((tourData) => tourData.get('tour').get('operator').id)
                    .values()
                    .map((operatorTours) => {
                        const sortedTours = _.sortBy(operatorTours, (operatorTour) => operatorTour.get('finalPrice'));
                        const cheapestSortedTour = sortedTours[0];
                        if (cheapestSortedTour.get('tour')?.get('promoSegmentId')) {
                            isPromoTooltipVisible = true;
                        }

                        return cheapestSortedTour.get('id');
                    })
                    .value();

                const cheapestTravelataTourWithTransfer = getCheapestTravelataTourWithTransfer(tours);
                if (cheapestTravelataTourWithTransfer && !tourIdentities.includes(cheapestTravelataTourWithTransfer.get('id'))) {
                    tourIdentities.push(cheapestTravelataTourWithTransfer.get('id'));
                }

                if (isPromoTooltipVisible) {
                    const tooltipWrapper = $(this.$el).find('.promo-tooltip__wrapper').get(0);

                    if (!tooltipWrapper.children.length) initCommonPromoTooltip(tooltipWrapper);
                }

                return (`${shoucaseUrl}/hotel/${hotelId}/tourPage?${$.param({ identities: tourIdentities })}#?${$.param(paramsForRouter)}`);
            },
        },
        existsOperators: {
            deps: ['similarProducts'],
            get(similarProducts) {
                const operators = _.chain([this.model, ...similarProducts])
                    .map((tour) => tour.get('product')?.get('operator')?.name)
                    .compact()
                    .uniq()
                    .value()
                    .join(', ');

                return _.unescape(operators);
            },
        },
    },
})
export default class TourProductView extends Backbone.Epoxy.View {
    initialize(options) {
        const self = this;

        if (options.collectionView) {
            this.collectionView = options.collectionView;
            this.listenTo(this.model, 'change', $.proxy(self.render, self));
            this.listenTo(this.model.get('tour'), 'change', $.proxy(self.render, self));
            this.roomInfoDg = options.collectionView.roomInfoDg || null;
            this.render();
        }

        this.initMapStates();
    }

    initMapStates() {
        this.viewModel.mapState('roomDescription', this.model.get('tour'));
    }

    openRoomInfoDg(e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.roomInfoDg) {
            this.roomInfoDg.open(this);
        }
    }

    hideRoomDescription(event) {
        const owner = this.$el.find('.HtlTrItemOwner');

        owner.find('.roomDescription').slideUp();
        owner.removeClass('openedDescription');

        event.stopPropagation();
    }

    tourSelectedOperators() {
        const identity = this.model.get('id');
        const tour = this.model.get('tour');
        const { dataLayerAnalytics } = this.collectionView.parentView;
        const value = {};
        if (tour && tour.get('price')) {
            ls.set(this.model.get('id'), tour.get('priceWithOilTax'));
        }
        value.prop1 = dataLayerAnalytics.createRangeEvent(this.getPropertyForTourClick());
        value.prop2 = [{ type: 'identity', id: identity }];
        dataLayerAnalytics.generateEvent('hotelClick', value);
    }

    render() {
        this.generateTemplate();
        this.collectionView.model.trigger('change');
        this.renderPartialPaymentBanner();
        const shouldRender = this.model.get('tour');
        if (shouldRender) {
            const objectTourProductForRender = generateObjectToutProductFromRender(this);
            this.model.set({
                objectTourProductForRender,
            });
            this.$el.html(this.template(objectTourProductForRender));
            this.initViews();
            this.applyBindings();
            this.initViewsAfterRender();
        }
    }

    renderPartialPaymentBanner() {
        const tour = this.model.get('tour');
        const percentPaymentDefinition = this.model
            ?.get('firstPaymentDefinition')
                ?.firstPaymentPart;

        if (percentPaymentDefinition) {
            tour.set({
                percentValue: percentPaymentDefinition,
            });
        }
    }

    partnerScriptCall() {
        if (this.collectionView) {
            ecommerceService.productClickHotel({
                product: this.model,
                category: 'tour',
                pageType: 'tour',
                departureCityName: this.collectionView.model.get('searchData').get('departureCity').get('name'),
                collection: this.collectionView.collection,
            });
        }
    }

    generateTemplate() {
        this.template = tourProductComponentTemplate;
    }

    getPropertyForTourClick() {
        const hotelId = window.appConfig.hotelInfo.id;
        const tour = this.model.get('tour');

        return getPropertyForTourClick({ tour, hotelId });
    }

    initViews() {
        if (this.model.get('tour').get('freeCancellation')) {
            new FreeCancellationInscriptionDesktop({
                el: $('.freeCancellation__inscription', this.$el),
            });
        }

        new SimilarToursSelectDesktop({
            el: this.$el.find('.js-similar-tours'),
            model: this.model,
            gotoTourPage: this.tourSelectedOperators,
            controllerModel: this.collectionView.model,
        });

        new RoomCategoryPhotos({
            model: this.model.get('tour'),
            el: $('.js-room-category-photos', this.$el),
        });
    }

    initViewsAfterRender() {
        this.warrantyTooltip = new TooltipPopoverHtml({
            el: $('.js-warranted-icon', this.$el),
        });
    }
}
